import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "advertisement-container"
};
var _hoisted_2 = ["onClick"];
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import { jumpInteractionType, imageCutEdgeAndSetSize } from '@/utils/common';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
export default {
  __name: 'AdvertisingSpace',
  props: {
    properties: {
      type: Object,
      require: true,
      default: () => {
        return {};
      }
    }
  },
  setup(__props) {
    useLess('views/landingPage/advertisingSpace/AdvertisingSpace.less');
    var route = useRoute();
    var router = useRouter();
    var LAYOUT_TYPE = Object.freeze({
      ENDTISE_TILED: 'ENDTISE_TILED',
      TRANSVERSE_TILED: 'TRANSVERSE_TILED'
    });

    // Click on the image to trigger jump logic
    var onClickImg = advertisementItem => {
      jumpInteractionType(advertisementItem, router);
    };
    onMounted(() => {
      var recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.advertisingSpaceWidget), recordParams));
    });
    return (_ctx, _cache) => {
      var _directive_reload_img = _resolveDirective("reload-img");
      var _directive_loading = _resolveDirective("loading");
      return __props.properties.isShow === 'DISPLAY' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass([{
          'advertisement-wrapper-bottom6': __props.properties.bottomSpacing == '6'
        }, {
          'advertisement-wrapper-bottom12': __props.properties.bottomSpacing == '12'
        }, {
          'advertisement-wrapper-bottom20': __props.properties.bottomSpacing == '20'
        }, {
          'advertisement-wrapper-column': __props.properties.layoutType === _unref(LAYOUT_TYPE).ENDTISE_TILED
        }, 'advertisement-wrapper'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.interactionTypeInfo, advertisementItem => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{
            'advertisement-area-right': __props.properties.layoutType === _unref(LAYOUT_TYPE).TRANSVERSE_TILED && __props.properties.imageSpacing !== 0
          }, {
            'advertisement-area-bottom': __props.properties.layoutType === _unref(LAYOUT_TYPE).ENDTISE_TILED && __props.properties.imageSpacing !== 0
          }, 'advertisement-area']),
          key: advertisementItem
        }, [_createElementVNode("div", {
          class: "advertisement-image",
          onClick: $event => onClickImg(advertisementItem)
        }, [_withDirectives(_createElementVNode("img", null, null, 512), [[_directive_reload_img, _unref(imageCutEdgeAndSetSize)(advertisementItem.picUrl)]])], 8, _hoisted_2)], 2);
      }), 128))], 2)])), [[_directive_loading, _ctx.loading]]) : _createCommentVNode("", true);
    };
  }
};